import store from "../store";

export default (to, from, next) => {
  
  var {user_details} = store.state.Auth.user?store.state.Auth.user:{user_details:null};
    
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.

    if (store.state.Auth.authState == false) {
      next({
        path: "/",
        query: { redirect: to.fullPath },
      });
    } else {
      if(!to.matched.some(record => record.meta.roles?.includes(user_details.role))){
        store.dispatch('Auth/logout')
        next({
          path: "/",
        });
      }
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
};
